import * as React from "react";
const SvgArrowUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 14.4L12.2965 8.10354L18.593 14.4", stroke: "currentColor", strokeWidth: 1.7, strokeLinecap: "round" }));
export default SvgArrowUp;
